// config.js

let backendbasurl=""
let backOfficeurl = ""
let paymentGateWayUrl = "";
const hostname = window && window.location && window.location.hostname;
if (hostname.includes("staging") || hostname.includes("localhost"))
    {
        backOfficeurl="https://backoffice-backend-staging.bullforce.co/"
    backendbasurl = "https://wealthvault-backend-staging.tradeboss.co/"
    paymentGateWayUrl = "https://payment-gateway-staging.tradeboss.co/"  
    }else{

        backOfficeurl="https://backoffice-backend.bullforce.co/"
    backendbasurl = "https://wealthvault-backend.tradeboss.co/"
    paymentGateWayUrl = "https://payment-gateway.tradeboss.co/"
    }

 
    
class AppConfig {
    static baseUrl = backendbasurl//process.env.REACT_APP_API_URL;
    static backofficeUrl = backOfficeurl;
    static authControlUrl = process.env.REACT_APP_AUTH_TOKEN_URL;
    static baseTokenUrl = process.env.REACT_APP_TOKEN_URL;
    static appRedirectUrl = process.env.REACT_APP_REDIRECT_URL;
    static paymentBaseUrl = paymentGateWayUrl;
    
    static api = {
        Login:{
            genOtp : `${this.baseUrl}authentication/login`,
            verifyOtp : `${this.baseUrl}authentication/otp_verification`,
            transaction : `${this.baseUrl}clients/subscription`
        },
        Subscription:{
            bankList : `${this.baseUrl}payment/banklist`,
            subscription : `${this.baseUrl}payment/subscriptionOrder`
        },
        Client: {
            info: `${this.backofficeUrl}report/clientinfo`,
            banks: `${this.baseUrl}report/clientbanks`,
            receipt: `${this.baseUrl}report/receipt`,
            holdings: `${this.baseUrl}report/holdings`,
            assets: `${this.baseUrl}report/assets`,
            getFnYear: `${this.baseUrl}report/yearinfo`,
            
        },  
        Payment: {
            payOrder: `${this.paymentBaseUrl}api/razorpay/payorder`,
            payStatus: `${this.paymentBaseUrl}api/razorpay/paystatus?orderId=`,
            callback: `${this.baseUrl}payment/callback`,
            info: `${this.baseUrl}payment/info`,
            list: `${this.baseUrl}payment/list`,
            pg_payOrder: `${this.baseUrl}pg/payorder`,
            // success : 'http://localhost:3000/dashboard'
        },
    }
     
    static removeQueryParams =  function(){
        const baseUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, baseUrl);
    }
 
    static paymentGateWay = {
        theme: {
            color: "#1B2636",
        },
        currency: "INR",
        name: process.env.REACT_APP_RAZOR_NAME,
        methodsObj: {
            netbanking: { "netbanking": 1},
            card: { "card": 1},
            upi: { "upi": 0},
            wallet: { "wallet": 0},
        }
    };
    static setBaseUrl(newBaseUrl) {
        AppConfig.baseUrl = newBaseUrl;
    };
  }
  
  export default AppConfig;
  